import { ref, reactive, onMounted, onUnmounted } from 'vue'
import axios from 'axios'



const useRequest = (url) => {
    const data = ref(null)
    const err = ref(null)
    const loading = ref(false)
    // 创建一个 CancelToken 对象
    const cancelTokenSource = axios.CancelToken.source();

    async function fetchData() {
        try {
            loading.value = true
            const response = await axios.get(url, { cancelToken: cancelTokenSource.token });

            data.value = await new Promise(resolve => {

                setTimeout(() => {
                    resolve(response.data)
                }, 2000)

            })

        } catch (error) {

            if (axios.isCancel(error)) {
                console.log(error.message);
                // 请求被取消的处理
                console.log('请求已被取消：', error.message);
            } else {
                err.value = error.message
                // 其他错误处理
                console.log('请求发生错误：', error.message);
            }

        } finally {

            loading.value = false

        }
    }


    onMounted(async () => {
        fetchData()
    })

    onUnmounted(() => {
        if (cancelTokenSource) {
            cancelTokenSource.cancel('组件卸载，请求被取消');
        }
    })
    return { data, loading, err }
}


export default useRequest